<div class="modal-dialog modal-lg">
    <div class="modal-content">
    
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">Importação de registros em massa</h4>
        <button #closeModal type="button" class="close" data-dismiss="modal">&times;</button>
    </div>
    
    <!-- Modal body -->
    <div class="modal-body">
        <p>Para importar os cargos, selecione abaixo o arquivo (.csv) e em seguida confira os dados.</p>

        <input type="file" #importar class="form-control" accept=".csv" (change)="importarCsv($event)">

        <nav *ngIf="cargosCriticados.length > 0 || newCargosArray.length > 0 || cargosDuplicados.length > 0 || cargosEnviados.length > 0" class="mt-3">
            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                <a *ngIf="cargosCriticados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavValidacao == true ? 'active' : '' "
                    id="nav-validacao-tab" data-toggle="tab" href="#nav-validacao" role="tab" aria-controls="nav-validacao" aria-selected="false">
                    Validação
                </a>
                <a *ngIf="cargosSemPlano.length > 0" class="nav-item nav-link" [ngClass]="ativaNavSemPlano == true ? 'active' : '' "
                    id="nav-sem-plano-tab" data-toggle="tab" href="#nav-sem-plano" role="tab" aria-controls="nav-sem-plano" aria-selected="false">
                    Sem Plano ou Agrupador
                </a>
                <a *ngIf="newCargosArray.length > 0 && cargosEnviados.length === 0" class="nav-item nav-link" 
                    [ngClass]="ativaNavEnviar == true ? 'active' : '' " id="nav-enviar-tab" data-toggle="tab" href="#nav-enviar" 
                    role="tab" aria-controls="nav-enviar" aria-selected="false">
                    Enviar
                </a>
                <a *ngIf="cargosDuplicados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavDuplicados === true ? 'active' : '' " 
                    id="nav-duplicados-tab" data-toggle="tab" href="#nav-duplicados" role="tab" aria-controls="nav-duplicados" 
                    aria-selected="true">
                    Duplicados
                </a>
                <a *ngIf="cargosEnviados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavEnviados === true ? 'active' : '' " 
                    id="nav-enviados-tab" data-toggle="tab" href="#nav-enviados" role="tab" aria-controls="nav-enviados" aria-selected="true">
                    Enviados
                </a>
            </div>
        </nav>
        <div *ngIf="cargosCriticados.length > 0 || newCargosArray.length > 0 || cargosDuplicados.length > 0 || cargosEnviados.length > 0 || cargosSemPlano.length > 0" class="tab-content" id="nav-tabContent">
            <div *ngIf="cargosCriticados.length > 0" class="tab-pane fade" [ngClass]="ativaNavValidacao == true ? 'show active' : '' " id="nav-validacao" role="tabpanel">
                <div class="mt-2">
                    <div class="alert alert-danger mt-2" role="alert">
                        <p class="mb-0">O(s) cargo(s) a seguir não passaram em alguma validação.</p>
                        <p class="mb-0">Validação 1: O título é obrigátório.</p>
                        <p class="mb-0">Validação 2: A quantidade deve ser maior que 0 (zero).</p>
                        <p class="mb-0">Validação 3: O label do cargo é obrigatório.</p>
                    </div>
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Título</th>
                                <th>Qtd. vagas</th>
                                <th>Crítica Validação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let critica of cargosCriticados">
                                <td>{{critica.novoCargo.nome}}</td>
                                <td>{{critica.novoCargo.qtdElegiveis}}</td>
                                <td>{{critica.critica}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div *ngIf="cargosSemPlano.length > 0" class="tab-pane fade" [ngClass]="ativaNavSemPlano == true ? 'show active' : '' " id="nav-sem-plano" role="tabpanel">
                <div class="alert alert-warning mt-2" role="alert">
                    <p class="mb-0">O(s) cargo(s) a seguir não possuem Plano ou Agrupador associado(s).</p>
                    <p class="mb-0">Caso deseje seguir com a importação deles, pressione "seguir" para que eles sejam adicionados à aba "Enviar".
                        Caso contrário, descarte o arquivo e faça as correções necessárias.</p>
                </div>
                <div class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Título</th>
                                <th>Informações</th>
                                <th>Label Cargo</th>
                                <th class="text-center">Qtd. vagas</th>
                                <th>Planos</th>
                                <th>Agrupador</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let sC of cargosSemPlano">
                                <td>{{sC.nome}}</td>
                                <td>{{sC.informacao}}</td>
                                <td>{{sC.labelCargo}}</td>
                                <td class="text-center">{{sC.qtdElegiveis}}</td>
                                <td>{{sC.plano}}</td>
                                <td>{{sC.agrupador}}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <button *ngIf="cargosSemPlano.length > 0" class="btn-custom btn btn-success mt-3" (click)="salvarCargosSemPlano()">
                    Seguir
                </button>
            </div>

            <div *ngIf="newCargosArray.length > 0" class="tab-pane fade" [ngClass]="ativaNavEnviar == true ? 'show active' : '' " id="nav-enviar" role="tabpanel">
                <div class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Título</th>
                                <th>Informações</th>
                                <th>Label Cargo</th>
                                <th class="text-center">Qtd. vagas</th>
                                <th>Planos</th>
                                <th>Agrupador</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of newCargosArray">
                                <td>{{c.nome}}</td>
                                <td>{{c.informacao}}</td>
                                <td>{{c.labelCargo}}</td>
                                <td class="text-center">{{c.qtdElegiveis}}</td>
                                <td>{{c.plano}}</td>
                                <td>{{c.agrupador}}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <button *ngIf="newCargosArray.length > 0" class="btn-custom btn btn-success mt-3" (click)="importarList()">
                    Salvar
                </button>
            </div>

            <div *ngIf="cargosDuplicados.length > 0" class="tab-pane fade" [ngClass]="ativaNavDuplicados === true ? 'show active' : '' " id="nav-duplicados" role="tabpanel">
                <div class="alert alert-danger mt-2" role="alert">
                    <p class="mb-0">Os cargos abaixo já estão cadastrados.</p>
                </div>
                <div *ngIf="cargosDuplicados.length > 0" class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Título</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let cargos of cargosDuplicados">
                                <td>{{cargos.nome}}</td>
                            </tr>
                        </tbody>
                    </table>              
                </div>
            </div>

            <div *ngIf="cargosEnviados.length > 0" class="tab-pane fade" [ngClass]="ativaNavEnviados === true ? 'show active' : '' " id="nav-enviados" role="tabpanel">
                <div class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Título</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let cargo of cargosEnviados">
                                <td>{{cargo.nome}}</td>
                            </tr>
                        </tbody>
                    </table>              
                </div>
            </div>
        </div>
        <hr>
        <button class="btn-custom btn btn-light mr-2" (click)="zerarInputFile(importar)">
            Descartar arquivo
        </button>  
    </div>        
    </div>
</div>